import { render, staticRenderFns } from "./Cell.vue?vue&type=template&id=d2f66738&scoped=true&"
import script from "./Cell.vue?vue&type=script&lang=ts&"
export * from "./Cell.vue?vue&type=script&lang=ts&"
import style0 from "./Cell.vue?vue&type=style&index=0&id=d2f66738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f66738",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VTooltip})
